export default __webpack_public_path__ + "static/media/cloud-download.db98c09b.svg";